import { useCallback, useEffect, useState } from 'react';
import type { SettingsSaveState } from './SettingsSaveStatus';

const SAVED_VISIBLE_MS = 3000;

/** The save status of a tab that saves each control at once: "Saved" goes away after 3 s. */
export function useSettingsSaveState(): {
  state: SettingsSaveState;
  setState: (state: SettingsSaveState) => void;
} {
  const [state, setStateRaw] = useState<SettingsSaveState>('idle');

  useEffect(() => {
    if (state !== 'saved') {
      return undefined;
    }
    const timer = setTimeout(() => setStateRaw('idle'), SAVED_VISIBLE_MS);
    return () => clearTimeout(timer);
  }, [state]);

  const setState = useCallback((next: SettingsSaveState) => setStateRaw(next), []);
  return { state, setState };
}
